import React, { useState } from 'react';

import { useBoolean } from 'hooks/useBoolean';
import { setLocalisationData } from 'providers/useLocalisationStore';
import { getCreatorDetails } from 'services/api';

import { get } from '../lib/api';

const AccountContext = React.createContext({
  user: {},
  onUpdateUser: () => {},
});

const AccountProvider = ({ userData, children }) => {
  const [user, setUser] = useState(userData || {});
  const [isUgcUser, setIsUgcUser] = useState(false);
  const [isHindiUgcUser, setIsHindiUgcUser] = useState(false);
  const [isHindiSeries, setIsHindiSeries] = useState(false);
  const [isEnglishSeries, setIsEnglishSeries] = useState(false);
  const [isAccountDetailsLoading, setLoading] = useState(false);

  const [isEarnPageShown, setEarnPageShown] = useState(false);
  const [updateChapter, setUpdateChapter] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [wbpContractWithPerfios, setWbpContractWithPerfieos] = useState(false);
  const [isWriterLocalisation, setWriterLocalisation] = useState(false);
  const [wbpInvite, setWbpInvite] = useState(false);
  const SOURCE_APP_NOVELS = ['android', 'ios'];
  const SOURCE_APP_FM = ['pfm_android', 'pfm_ios'];
  const sourceApp = localStorage.getItem('source_app');

  const handleUpdateUser = async () => {
    setLoading(true);
    // beta call for all the beta features
    const res = await get(
      '/user_api/user.is_beta_release_enabled_v2?is_novel=1',
      {
        params: {
          features: [
            'perfios_integration',
            'earn_page_v1',
            'update_chapter',
            'show_notifications',
            'invite_only_wbp',
            'writer_localisation',
          ],
        },
      }
    );
    const { features } = res;
    setEarnPageShown(features?.enable_earn_page_v1);
    setUpdateChapter(features?.enable_update_chapter);
    setWbpContractWithPerfieos(features?.enable_perfios_integration);
    setShowNotifications(features?.enable_show_notifications);
    setWbpInvite(features?.enable_invite_only_wbp);
    setWriterLocalisation(features?.enable_writer_localisation);

    if (features?.enable_writer_localisation) {
      // if localization is enabled
      // localization api call
      const localisationRes = await get(
        '/localisation/creators/content/',
        'v3'
      );
      if (!localStorage.getItem('content_format')) {
        localStorage.setItem(
          'content_format',
          localisationRes?.data?.content_format
        );
        localStorage.setItem(
          'content_format_language',
          localisationRes?.data?.language[localisationRes?.data?.content_format]
        );
      }
      setLocalisationData(localisationRes.data);
      const currentContentFormat =
        localStorage.getItem('content_format') ||
        localisationRes?.data?.content_format;

      // now I can pass content format if I want
      const { result: data } = await getCreatorDetails({
        content_format: currentContentFormat,
      });
      setUser(data);
      // writing the logic to setIsUgcUser and setIsHindiUgcUser
      if (currentContentFormat === 'series') setIsUgcUser(true);
      else setIsUgcUser(false);

      setIsHindiSeries(
        currentContentFormat === 'series' &&
          localStorage.getItem('content_format_language') === 'hindi'
      );
      setIsEnglishSeries(
        currentContentFormat === 'series' &&
          localStorage.getItem('content_format_language') === 'english'
      );
      setLoading(false);
    } else {
      // if localization is not enabled

      // get creator details
      const { result: data } = await getCreatorDetails();
      setUser(data);

      // writing the logic to setIsUgcUser and setIsHindiUgcUser
      const uid = data?.uid || localStorage.getItem('uid');
      if (!SOURCE_APP_NOVELS.includes(sourceApp)) {
        // means user is coming from FM app or web
        get(`/user_api/user.is_hindi_ugc_beta_user?uid=${uid}&is_novel=1`).then(
          (response) => {
            if (
              SOURCE_APP_FM.includes(sourceApp) &&
              response?.beta_user === 1
            ) {
              // if user is coming from FM
              setIsUgcUser(true);
              setIsHindiUgcUser(false);
            } else {
              // user is coming from web
              setIsHindiUgcUser(
                response?.beta_user === 1 &&
                  data?.location &&
                  data?.location === 'IN' &&
                  data?.languages === 'hindi'
              );
              setIsUgcUser(data?.location && data?.languages === 'english');
            }
            setLoading(false);
          }
        );
      } else setIsUgcUser(data?.location && data?.languages === 'english');
      setLoading(false);
    }
  };
  return (
    <AccountContext.Provider
      value={{
        isAccountDetailsLoading,
        user,
        isUgcUser,
        isHindiUgcUser,
        isEarnPageShown,
        onUpdateUser: handleUpdateUser,
        updateChapter,
        wbpContractWithPerfios,
        showNotifications,
        wbpInvite,
        isWriterLocalisation,
        isHindiSeries,
        isEnglishSeries,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};

export { AccountContext };
export default AccountProvider;
